// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__iKP8N","row":"styles_row___dQfm"};